import type { NavigationMenuItem } from './navigationMenu';
import { navigationMenuItems } from './navigationMenu';

type PathEntry = { path: string; text: string };

function flattenMenuPaths(items: NavigationMenuItem[]): PathEntry[] {
  const out: PathEntry[] = [];
  for (const item of items) {
    out.push({ path: item.path, text: item.text });
    if (item.subItems?.length) {
      for (const sub of item.subItems) {
        out.push({ path: sub.path, text: sub.text });
      }
    }
  }
  return out;
}

/**
 * Título de pantalla legible según la ruta: coincide con el ítem del menú más específico.
 */
export function resolvePageTitleFromPath(pathname: string): string {
  const normalized = (pathname.replace(/\/+$/, '') || '/').trim();
  const entries = flattenMenuPaths(navigationMenuItems);
  let best: PathEntry | null = null;
  for (const e of entries) {
    if (normalized === e.path || normalized.startsWith(`${e.path}/`)) {
      if (!best || e.path.length > best.path.length) {
        best = e;
      }
    }
  }
  if (best) {
    return best.text;
  }
  const parts = normalized.split('/').filter(Boolean);
  if (parts.length === 0) {
    return 'Inicio';
  }
  const last = parts[parts.length - 1] ?? '';
  return last
    .split('-')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}
